import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
/* import { logout } from '../helpers/asyncActions'; */
/* import Wrapper from '../components/core/Wrapper'; */
import VerifyEmailPhone from '../components/Modals/VerifyEmailPhone';
import Main from '../layouts/Main';
import {
  getNewMeeting,
  getNewNotification,
  getNotificationItems,
} from '../helpers/users';
import LogoIcon from '../images/icons/logo_icon.svg';
import { useGlobalContext } from '../stores/global';
import styles from './MeProfile.module.scss';

const items = [
  /* {
    onlySeller: false,
    name: 'Mis propiedades',
    href: '/me/properties',
  },
    {
    name: 'Mis mensajes',
    href: '/messages',
  }, */
  {
    onlySeller: false,
    name: 'Tus favoritos',
    href: '/favorites',
  },
  /* {
    name: 'Mis citas',
    href: '/appointments',
  },
  {
    onlySeller: true,
    name: 'Citas de mis propiedades',
    href: '/seller/appointments',
  }, */
  {
    onlySeller: false,
    name: 'Ajustes',
    href: '/me/settings',
  },
];

export default function MeProfile() {
  const { user, /* dispatch */ } = useGlobalContext();
  const [verifyModal, setVerifyModal] = useState(false);
  const [newNotificationView, setNewNotificationView] = useState<any>(false);
  const [newMeetingView, setNewMeetingView] = useState<any>(false);
  const chatMessagesPollingIntervalRef = useRef<number>();

  const { isEmailOrPhoneVerified } = getNotificationItems(user);

  if (!user) {
    return null;
  }

  // Polling notification
  const startNotificationPolling = () => {
    setNewNotificationView(getNewNotification().newNotification);
    setNewMeetingView(getNewMeeting().newMeeting);
    window.clearInterval(chatMessagesPollingIntervalRef.current);
    chatMessagesPollingIntervalRef.current = window.setInterval(() => {
      setNewNotificationView(getNewNotification().newNotification);
      setNewMeetingView(getNewMeeting().newMeeting);
      // }, 5000 * 100000); // TODO: enable polling again
    }, 5000);
  };

  useEffect(() => {
    startNotificationPolling();
    return () => {
      window.clearInterval(chatMessagesPollingIntervalRef.current);
    };
  }, []);

  const isSeller = user.role === 'vendedor';

  return (
  <Main>
    {/* <Wrapper subHeader={{ title: 'CUENTA' }}> */}
    <div className={styles.mainDiv}>
      <div className={styles.content}>
        <h2 className={styles.title}>Mi perfil</h2>

        <p className={styles.name}>{user.name}</p>
        <p className={styles.email}>{user.email}</p>

        <div className={styles.items}>
          {items.map((item) =>
            item.onlySeller && !isSeller ? null : (
              <Link key={item.name} to={item.href}>
                {item.href === '/messages' && newNotificationView && (
                  <div className={styles.notification} />
                )}
                {item.href === '/seller/appointments' && newMeetingView && (
                  <div className={styles.notification} />
                )}
                <img src={LogoIcon} />
                {item.name}
              </Link>
            )
          )}
          <button onClick={() => console.log("abrir notificaciones")}>
            <img src={LogoIcon} />
            Configura tus notificaciones
          </button>
          <button onClick={() => console.log("abrir suscripciones")}>
            <img src={LogoIcon} />
            Tu suscripción
          </button>
          {!isEmailOrPhoneVerified && (
            <button onClick={() => setVerifyModal(true)}>
              <div className={styles.notification} />
              <img src={LogoIcon} />
              Verificar cuenta
            </button>
          )}
{/*           <button onClick={() => logout(dispatch)}>
            <img src={LogoIcon} />
            Cerrar sesión
          </button> */}
        </div>
      </div>

      {verifyModal && (
        <VerifyEmailPhone onClose={() => setVerifyModal(false)} />
      )}
      </div>
{/*     </Wrapper> */}
    </Main>
  );
}
